import React from 'react';
import { css } from '@emotion/core';
import { productColor, textColor, grayScale } from 'components/styles';
import BaseButton, { ButtonProps } from './BaseButton';

/**
 * プライマリボタン
 *
 * @see https://sketch.cloud/s/2b3Pe/a/k9qkrA
 */
const DeleteButton: React.FC<ButtonProps> = ({
  text, onClick, disabled, ghost, children, fullwidth = false, minWidth='120px', customStyle = css({})
}) => (
  <BaseButton
    color={{
      baseColor: productColor.deleteAction,
      textColor: textColor.inversed,
      ghostColor: productColor.deleteAction,
      ghostTextColor: productColor.deleteAction,
      hoverColor: disabled ? grayScale.gray20 : productColor.deleteActionHover,
      focusColor: productColor.deleteAction,
    }}
    text={text}
    onClick={onClick}
    disabled={disabled}
    ghost={ghost}
    fullwidth={fullwidth}
    minWidth={minWidth}
    customStyle={customStyle}
  >
    {children}
  </BaseButton>
);

export default DeleteButton;
